'use client';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const getStyles = (theme, { verticalSpacing, spacing, cols })=>{
    const hasVerticalSpacing = verticalSpacing != null;
    const verticalGap = theme.fn.space(hasVerticalSpacing ? verticalSpacing : spacing);
    const horizontalGap = theme.fn.space(spacing);
    const gridGap = `${verticalGap} ${horizontalGap}`;
    return {
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gap: gridGap
    };
};
var useStyles = createStyles((theme, _param)=>{
    var { breakpoints } = _param, params = _object_without_properties_loose(_param, [
        "breakpoints"
    ]);
    return {
        root: _extends({
            boxSizing: 'border-box',
            display: 'grid'
        }, getStyles(theme, params), theme.fn.responsive(breakpoints)((params)=>getStyles(theme, params)))
    };
});

export { useStyles as default, getStyles };
//# sourceMappingURL=SimpleGrid.styles.js.map
